const appConfig = {
  API_HOST: process.env.REACT_APP_API_URL,
  API_FILE: process.env.REACT_APP_API_FILE,
};
export default appConfig;
